<template lang="jade">
  .information(flex="dir:top", flex-box="1")
    .top-banner(flex="dir:left main:justify cross:center", flex-box="0")
      a.logo(href="https://www.vipkid.com/mkt/affiliate-program", flex-box="0")
        img(src="./logo.png")
      a.btn(href="/login", flex-box="0") Sign In
    .form-box(v-if="!success", flex-box="1")
      section
        .title Essential information
        .input-box(flex="dir:left main:justify cross:center")
          .side-box(flex-box="0")
            input(
              type="text",
              placeholder="First Name",
              v-model="from.firstName.value",
              @blur="changeActive(from.firstName)",
              :class="{'error_input':(showError||from.firstName.isActive)&&!from.firstName.isTrue}"
            )
            p.error(
              :class="{'show-error':showError||from.firstName.isActive}"
            ) {{from.firstName.value | nameFilter(from.firstName)}}
          .side-box(flex-box="0")
            input(
              type="text",
              placeholder="Last Name",
              v-model="from.lastName.value",
              @blur="changeActive(from.lastName)",
              :class="{'error_input':(showError||from.lastName.isActive)&&!from.lastName.isTrue}"
            )
            p.error(
              :class="{'show-error':showError||from.lastName.isActive}"
            ) {{from.lastName.value | nameFilter(from.lastName)}}
        .input-box
          input(
            type="text",
            placeholder="Contact Email",
            v-model="from.contactEmail.value",
            @blur="changeActive(from.contactEmail)",
            :class="{'error_input':(showError||from.contactEmail.isActive)&&!from.contactEmail.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.contactEmail.isActive}"
          ) {{from.contactEmail.value | emailFilter(from.contactEmail)}}
        .input-box
          input(
            type="number",
            placeholder="Phone Number",
            v-model="from.phoneNumber.value",
            oninput="if(value.length>16)value=value.slice(0,16)"
            @blur="changeActive(from.phoneNumber)",
            :class="{'error_input':(showError||from.phoneNumber.isActive)&&!from.phoneNumber.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.phoneNumber.isActive}"
          ) {{from.phoneNumber.value | numFilter(from.phoneNumber)}}
        .input-box
          input(
            type="text",
            placeholder="Company Name",
            v-model="from.companyName.value",
            @blur="changeActive(from.companyName)",
            :class="{'error_input':(showError||from.companyName.isActive)&&!from.companyName.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.companyName.isActive}"
          ) {{from.companyName.value | charactersFilter(from.companyName)}}
        .input-box
          input(
            type="text",
            placeholder="Company Website / Blog Site / Online presence",
            v-model="from.companyWebsite.value",
            @blur="changeActive(from.companyWebsite)",
            :class="{'error_input':(showError||from.companyWebsite.isActive)&&!from.companyWebsite.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.companyWebsite.isActive}"
          ) {{from.companyWebsite.value | allFilter(from.companyWebsite)}}
        .input-box
          select(
            v-model="from.companyType.value",
            @blur="changeActive(from.companyType)",
            :class="{'error_input':(showError||from.companyType.isActive)&&!from.companyType.isTrue}"
          )
            option(value="") Company type
            option(value="Recruiting company") Recruiting company
            option(value="ESL teaching program") ESL teaching program
            option(value="Blogger") Blogger
            option(value="Marketing agency") Marketing agency
            option(value="School staff") School staff
            option(value="Others") Others
          p.error(
            :class="{'show-error':showError||from.companyType.isActive}"
          ) {{from.companyType.value | allFilter(from.companyType)}}
        .input-box
          input(
            type="text",
            placeholder="Number of potential teachers in your network",
            v-model="from.potentialTeacherNumber.value",
            @blur="changeActive(from.potentialTeacherNumber)",
            :class="{'error_input':(showError||from.potentialTeacherNumber.isActive)&&!from.potentialTeacherNumber.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.potentialTeacherNumber.isActive}"
          ) {{from.potentialTeacherNumber.value | allFilter(from.potentialTeacherNumber)}}
        .input-box
          textarea(
            placeholder="Description of your business",
            v-model="from.businessDescription.value",
            @blur="changeActive(from.businessDescription)",
            :class="{'error_input':(showError||from.businessDescription.isActive)&&!from.businessDescription.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.businessDescription.isActive}"
          ) {{from.businessDescription.value | allFilter(from.businessDescription)}}
        .input-box
          textarea(
            placeholder="Through what channels will you market to potential teachers",
            v-model="from.channels.value",
            @blur="changeActive(from.channels)",
            :class="{'error_input':(showError||from.channels.isActive)&&!from.channels.isTrue}"
          )
          p.error(
            :class="{'show-error':showError||from.channels.isActive}"
          ) {{from.channels.value | allFilter(from.channels)}}
        .input-box.verification-box(flex="dir:left")
          .side-box.verify-code-input(flex-box="0")
            input(
              type="text",
              placeholder="Verification code",
              v-model="from.imageCode.value",
              @blur="changeActive(from.imageCode)",
              @focus="focusImageCode",
              :class="{'error_input':(showError||from.imageCode.isActive)&&!from.imageCode.isTrue}"
            )
            p.error(
            :class="{'show-error':showError||from.imageCode.isActive}"
            ) {{from.imageCode.value | imageCodeFilter(from.imageCode)}}

          .side-box.verify-code-img(flex-box="0")
            img(alt='verification code', :src='imageCodeImgSrc', @click='getVerifyCode()')

        .label-box.auto
          input(
            name='is-agree',
            type="checkbox",
            id="all-agree",
            value=true,
            v-model="from.isAgree.value"
          )
          label(for="all-agree")
            | By entering my own name/company name below, l warrant that l have read and understand
            | fully the content and meaning of the&nbsp;
            a.import(href="/protocol", target="_blank") Referral Service Agreement
            | &nbsp;and l am willing to enter into this agreement and agreed all terms of the agreement,
            | including but not limited to arbitration clause and class action waiver, and no action
            | will be taken by or on behalf of the undersigned with respect to any such terms.
          p.error(
            :class="{'show-error':showError||from.isAgree.isActive}"
          ) {{from.isAgree.value | agreeFilter(from.isAgree)}}
        .btn-box(flex="dir:left")
          .btn(flex-box="0", @click="validateFrom") Apply
    .success-box(v-else, flex-box="1")
      .success-bg(flex="cross:center main:center")
        .tips(flex="dir:left cross:top main:center")
          .logo
            img(src="./success-tips.png")
          .msg
            h2 Your information has been submitted.
            p
              | Thank you for your interest in becoming our affiliate partner! Our team
              | will review your application and get back to you via email in 5 business days.
            a(href="https://www.vipkid.com/mkt/affiliate-program", target="_blank") Learn more about the affiliate program >
    .tp-footer(flex-box="0") &copy; VIPKID Beijing ICP 14002500
</template>

<script>
  import { ElementMessageMixin } from 'api/utils.js'
  import information from '../../api/information'
  export default {
    mixins: [ ElementMessageMixin ],
    data () {
      return {
        success: false,
        showError: false,
        imageCodeImgSrc: '',
        from: {
          firstName: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          lastName: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          contactEmail: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          phoneNumber: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          companyName: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          companyWebsite: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          companyType: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          potentialTeacherNumber: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          businessDescription: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          channels: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          isAgree: {
            value: false,
            isRequired: true,
            isTrue: true,
            isActive: false
          },
          imageCode: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: false,
            imageCodeError: true
          },
          key: {
            value: '',
            isRequired: true,
            isTrue: true,
            isActive: true
          }
        }
      }
    },
    mounted () {
      this.getVerifyCode()
    },
    methods: {
      getVerifyCode () {
        information.getVerifycode().then(res => {
          this.imageCodeImgSrc = res.data.data.value
          this.from.key.value = res.data.data.key
        }).catch(e => {
          console.log(e)
        })
      },
      changeActive (item) {
        if (Object.prototype.toString.call(item.value) === '[object String]') item.value = item.value.trim()
        item.isActive = true
      },
      focusImageCode () {
        this.from.imageCode.imageCodeError = true
      },
      validateFrom () {
        this.showError = true
        let params = {}
        for (let name of Object.keys(this.from)) {
          params[name] = this.from[name].value
          if (!this.from[name].isTrue) return
        }
        delete params.isAgree

        let defaultErrorMsg = 'Fail to get data from server, please try later.'
        information.essential(params).then(res => {
          // 临时的错误处理，迁移后不要这样搞
          let data = (res && res.data) || {}
          if (data.code + '' === '200') {
            this.success = true
          } else {
            this.$error(data.message || defaultErrorMsg)

            // 临时处理方案，大概率都是验证码错误，其他错误有校验，提交不了
            if (data.message === 'Verification code error.') {
              this.imageCodeErrorHandle()
            }
          }
        }).catch(e => {
          this.imageCodeErrorHandle()
        })
      },
      imageCodeErrorHandle () {
        this.from.imageCode.imageCodeError = false
        this.from.imageCode.isTrue = false
      }
    },
    filters: {
      nameFilter (val, item) {
        // 非空验证
        if (val === '' && item.isRequired) {
          item.isTrue = false
          return 'Please don\'t leave this blank!'
        }
        // 不能连续出现 ('') (..)  (··)
        if (val.indexOf('..') > -1 || val.indexOf(`''`) > -1 || val.indexOf('··') > -1) {
          item.isTrue = false
          return `Only accept English characters.`
        }
        // '·', '.' 和 ' 不能出现在最后
        if (val.length !== 0 &&
          (
            val.lastIndexOf(`'`) === val.length - 1 ||
            val.lastIndexOf('.') === val.length - 1 ||
            val.lastIndexOf('·') === val.length - 1
          )
        ) {
          item.isTrue = false
          return `Only accept English characters.`
        }
        // · 和. 不能出现在第一位
        if (val.indexOf('.') === 0 || val.indexOf('·') === 0) {
          item.isTrue = false
          return `Only accept English characters.`
        }
        // 不能有数字
        let newStr = val.replace(/\./g, 'a').replace(/'/g, 'a').replace(/·/g, 'a')
        if (!/^([A-Za-z]+\s?)*[A-Za-z]$/.test(newStr) && newStr) {
          item.isTrue = false
          return 'Only accept English characters.'
        }
        item.isTrue = true
      },
      emailFilter (val, item) {
        if (val === '' && item.isRequired) {
          item.isTrue = false
          return 'Please don\'t leave this blank!'
        }
        if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(val.trim())) {
          item.isTrue = false
          return 'Email format incorrect!'
        }
        item.isTrue = true
      },
      numFilter (val, item) {
        if (val === '' && item.isRequired) {
          item.isTrue = false
          return 'Please don\'t leave this blank!'
        }
        if (!/^[0-9\s]*$/.test(item.value)) {
          item.isTrue = false
          return 'Your phone number can only be numbers.'
        }
        item.isTrue = true
      },
      charactersFilter (val, item) {
        if (val === '' && item.isRequired) {
          item.isTrue = false
          return 'Please don\'t leave this blank!'
        }
        item.isTrue = true
      },
      imageCodeFilter (val, item) {
        let errorInfo = 'Your verification code is incorrect.\n'
        if (val === '' && item.isRequired) {
          item.isTrue = false
          return errorInfo
        }
        if (val !== '' && !item.imageCodeError) {
          item.isTrue = false
          item.imageCodeError = false
          return errorInfo
        }
        item.isTrue = true
        item.imageCodeError = true
      },
      allFilter (val, item) {
        if (val === '' && item.isRequired) {
          item.isTrue = false
          return 'Please don\'t leave this blank!'
        }
        item.isTrue = true
      },
      agreeFilter (val, item) {
        if (item.isRequired && !val) {
          item.isTrue = false
          return 'Please don\'t leave this blank!'
        }
        item.isTrue = true
      }
    },
    watch: {}
  }
</script>
<style lang="stylus" scoped>
  .information
    background #f7f5f4
    min-width 1200px
    .import
      color #F85415
      text-decoration underline
    .top-banner
      font-family Roboto-Regular
      background #FFFFFF
      padding 0 60px
      .logo
        width 100px
        padding 10px
        background #F85415
        img
          display block
          width 100%
      .btn
        width 90px
        height 30px
        line-height 30px
        text-align center
        border-radius 2px
        border solid 1px #f85415
        color #f85415
        text-decoration: none;
        &:hover
          color #FFFFFF
          border-color #f85415
          background #f85415
    .form-box
      margin 20px 60px
      background #FFFFFF
      padding 30px 0
      section
        max-width 600px
        margin auto
      .title
        font-family: Roboto-Regular;
        font-size 24px
        color #F85415
      .input-box
        margin-top 10px
        .side-box
          width 45%
        .verify-code-input
          width: 245px
        .verify-code-img
          cursor: pointer
          width: 70px
          height: 40px
          img, span
            width: 100%
            height: 100%
        .input-explain
          margin-left 5px
          font-family: Roboto-Regular;
          font-size 16px
          margin-bottom 15px
        input[type='text'], input[type='tel'], input[type='number'], select
          outline none
          box-sizing border-box
          height 40px
          border-radius 5px
          border 1px solid #dadada
          padding 0 10px
          font-size 14px
          line-height 40px
          background #fff
          opacity .75
          width 100%
          &.error_input
            border 1px solid #F62020 !important
          &:hover
            border 1px solid #F85415
        textarea
          outline none
          box-sizing border-box
          border-radius 5px
          border 1px solid #dadada
          max-width 890px
          width 100%
          height 180px
          padding 0 10px
          font-size 14px
          line-height 1.5
          background #fff
          opacity .75
          resize none
          &.error_input
            border 1px solid #F62020 !important
          &:hover
            border 1px solid #F85415
      .verification-box.input-box
        input
          width: 225px
      .label-box
        margin-top 20px
        width 100%
        input[type='checkbox']
          display none
        input[type='checkbox'] + label
          position relative
          cursor pointer
          display block
          color rgba(0, 0, 0, .75)
          font-size 14px
          line-height 20px
          padding-left 30px
          &:after
            content ''
            box-sizing border-box
            position absolute
            left 0
            top 3px
            width 14px
            height 14px
            background #ffffff
            border-radius 3px
            border 1px solid #cccccc
        input[type='checkbox']:checked + label
          &:before
            content ''
            box-sizing border-box
            position absolute
            top 5px
            left 2px
            width 10px
            height 10px
            background #73ba00
            border-radius 3px
            border 1px solid #73ba00
            z-index 1
      .btn-box
        margin-top 20px
        .btn
          cursor pointer
          font-family: Roboto-light;
          width 100px
          height 45px
          line-height 45px
          font-size 20px
          text-align center
          border-radius 2px
          background-color #f85416
          color #FFFFFF
      .error
        color #f60
        font-size 12px
        height 12px
        margin-top 3px
        visibility hidden
        &.show-error
          visibility visible
    .success-box
      margin 20px 60px
      .success-bg
        background #FFFFFF
        padding 30px 0
        .tips
          width 600px
          .logo
            margin-right 30px
            img
              display block
              width 80px
          .msg
            h2
              font-family Roboto-Regular
              font-size 20px
            p
              margin-top 20px
              font-size 14px
              color #686868
            a
              text-decoration none
              font-family Roboto-Regular
              display inline-block
              margin-top 20px
              color #F85415
    .tp-footer
      font-family Roboto-Regular
      font-size: 14px;
      color: rgba(255, 255, 255, 0.75);
      line-height: 60px;
      height: 60px;
      width: 100%;
      background: #7B7B7B;
      text-align: center;
</style>



// WEBPACK FOOTER //
// information.vue?516468d3